<div class="sz-lap gj-lap">
  <div class="ures" *ngIf="!u"><ion-icon name="business-outline"></ion-icon>Válassz céget a fejlécben.</div>
  <ng-container *ngIf="u">
    <div class="n-fulek">
      <button type="button" [class.aktiv]="nezet === 'cimek'" (click)="nezet = 'cimek'">Címek</button>
      <button type="button" [class.aktiv]="nezet === 'tavolsagok'" (click)="nezet = 'tavolsagok'">Távolságok</button>
    </div>

    <!-- ═══ CÍMEK ═══ -->
    <ng-container *ngIf="nezet === 'cimek'">
      <div class="n-szuro-sor">
        <button type="button" class="ov-gomb fo" *ngIf="ir" (click)="uj()"><ion-icon name="add"></ion-icon>Új cím</button>
        <button type="button" class="ov-gomb" *ngIf="ir" (click)="telephelyCegbol()" title="A cégtörzsben megadott székhely felvétele telephelyként"><ion-icon name="business-outline"></ion-icon>Telephely a cég címéből</button>
        <button type="button" class="ov-gomb" *ngIf="ir" (click)="atvetelNyit()"><ion-icon name="people-outline"></ion-icon>Átvétel a Könyvelés partnertörzséből</button>
        <input type="search" [(ngModel)]="kereso" placeholder="Név, cím, adószám…" style="min-width:200px">
        <label>Fajta <select [(ngModel)]="fajtaSzuro"><option value="">Mind</option><option *ngFor="let f of fajtaLista" [value]="f.k">{{ f.v }} ({{ db(f.k) }})</option></select></label>
        <label><input type="checkbox" [(ngModel)]="inaktiv"> inaktívak is</label>
        <span class="spacer"></span>
        <a class="ov-link" routerLink="/gepjarmu/beallitasok">← Beállítások</a>
      </div>
      <p class="gj-figyelem" style="margin:10px 18px 0" *ngIf="!betolt && !vanTelephely"><ion-icon name="information-circle-outline"></ion-icon>
        <span>Még nincs telephely – innen indulnak az utak. Vedd fel a „Telephely a cég címéből” gombbal, vagy kézzel.</span></p>
      <div class="tabla-wrap">
        <table class="n-racs sz-racs">
          <thead><tr><th>Megnevezés</th><th>Fajta</th><th>Cím</th><th>Adószám</th><th>Csoport</th><th class="num">Utak</th><th></th></tr></thead>
          <tbody>
            <tr *ngFor="let c of lathato" class="kattinthato" [class.halvany-sor]="!c.aktiv" (click)="nyit(c)">
              <td><b>{{ c.nev }}</b> <span class="gj-jel" *ngIf="c.alap_telephely">alapértelmezett</span></td>
              <td>{{ fajtak[c.fajta] || c.fajta }}<span class="halvany" *ngIf="c.naplo_partner_id"> · Könyvelésből</span></td>
              <td>{{ c.teljes }}</td><td>{{ c.adoszam }}</td><td>{{ c.csoport }}</td>
              <td class="num">{{ c.ut_db || '' }}</td>
              <td><span class="sz-allapot" *ngIf="!c.aktiv" data-a="nincs">inaktív</span></td>
            </tr>
          </tbody>
        </table>
        <div class="sz-ures" *ngIf="!lathato.length && !betolt">Nincs cím.</div>
      </div>
    </ng-container>

    <!-- ═══ TÁVOLSÁGOK ═══ -->
    <ng-container *ngIf="nezet === 'tavolsagok'">
      <div class="n-szuro-sor" *ngIf="ir">
        <label>Honnan <select [(ngModel)]="tav.cim_a" (ngModelChange)="tavValt()" style="max-width:260px"><option [ngValue]="null">– cím –</option>
          <option *ngFor="let c of aktivCimek" [ngValue]="c.id">{{ c.nev }} – {{ c.teljes }}</option></select></label>
        <label>Hova <select [(ngModel)]="tav.cim_b" (ngModelChange)="tavValt()" style="max-width:260px"><option [ngValue]="null">– cím –</option>
          <option *ngFor="let c of aktivCimek" [ngValue]="c.id" [disabled]="c.id === tav.cim_a">{{ c.nev }} – {{ c.teljes }}</option></select></label>
        <label>Km <input type="text" inputmode="decimal" [(ngModel)]="tav.km" style="width:90px" (keydown.enter)="tavMent()"></label>
        <button type="button" class="ov-gomb fo" [disabled]="!tav.cim_a || !tav.cim_b || !tav.km" (click)="tavMent()"><ion-icon name="checkmark"></ion-icon>{{ tavMeglevo ? 'Módosítás' : 'Rögzítés' }}</button>
        <span class="spacer"></span>
        <input type="search" [(ngModel)]="tavKereso" placeholder="Keresés…" style="min-width:160px">
      </div>
      <p class="halvany" style="margin:8px 18px 0;font-size:12.5px">A távolság irányfüggetlen (A → B ugyanannyi, mint B → A). Az útrögzítő ebből ajánl km-t, ha a két cím között már rögzítettél utat.</p>
      <div class="tabla-wrap">
        <table class="n-racs sz-racs">
          <thead><tr><th>Egyik cím</th><th>Másik cím</th><th class="num">Km</th><th></th></tr></thead>
          <tbody>
            <tr *ngFor="let t of tavLathato" [class.kattinthato]="ir" (click)="ir && tavNyit(t)">
              <td><b>{{ t.a_nev }}</b><br><span class="halvany">{{ t.a_cim }}</span></td>
              <td><b>{{ t.b_nev }}</b><br><span class="halvany">{{ t.b_cim }}</span></td>
              <td class="num"><b>{{ km(t.km) }}</b></td>
              <td class="muv"><button type="button" class="kv-torol" *ngIf="ir" (click)="$event.stopPropagation(); tavTorol(t)" title="Törlés"><ion-icon name="trash-outline"></ion-icon></button></td>
            </tr>
          </tbody>
        </table>
        <div class="sz-ures" *ngIf="!tavLathato.length">Nincs rögzített távolság.</div>
      </div>
    </ng-container>
  </ng-container>
</div>

<!-- ═══ CÍM ═══ -->
<ion-modal [isOpen]="!!szerk" (didDismiss)="bezar()" cssClass="sorablak-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>{{ szerk?.id ? szerk.nev : 'Új cím' }}</ion-title></ion-toolbar></ion-header>
    <div class="sa-torzs">
      <div class="sa gj-ablak" *ngIf="szerk">
        <app-szerk-zar-sav [zar]="zar"></app-szerk-zar-sav>
        <div class="sa-doboz">
          <label class="kv-mezo"><span>Fajta</span><select [(ngModel)]="szerk.fajta" [disabled]="!ir"><option *ngFor="let f of fajtaLista" [value]="f.k">{{ f.v }}</option></select></label>
          <label class="kv-mezo"><span>Csoport</span><input type="text" [(ngModel)]="szerk.csoport" [disabled]="!ir" list="gjCimCsoportok" maxlength="60"></label>
          <datalist id="gjCimCsoportok"><option *ngFor="let c of csoportok" [value]="c"></option></datalist>
          <label class="kv-mezo gj-teljes"><span>Megnevezés *</span><input type="text" [(ngModel)]="szerk.nev" [disabled]="!ir" maxlength="160" placeholder="pl. a partner neve, „Központ”, „Otthon”"></label>
          <label class="kv-mezo"><span>Irányítószám</span><input type="text" [(ngModel)]="szerk.irsz" [disabled]="!ir" maxlength="10"></label>
          <label class="kv-mezo"><span>Település</span><input type="text" [(ngModel)]="szerk.telepules" [disabled]="!ir" maxlength="80"></label>
          <label class="kv-mezo gj-teljes"><span>Cím</span><input type="text" [(ngModel)]="szerk.cim" [disabled]="!ir" maxlength="160" placeholder="utca, házszám"></label>
          <label class="kv-mezo"><span>Adószám</span><input type="text" [(ngModel)]="szerk.adoszam" [disabled]="!ir" maxlength="20"></label>
          <div class="sa-jelolok"><label><input type="checkbox" [(ngModel)]="szerk.aktiv" [disabled]="!ir"> aktív</label></div>
          <label class="kv-mezo gj-teljes"><span>Megjegyzés</span><input type="text" [(ngModel)]="szerk.megjegyzes" [disabled]="!ir" maxlength="255"></label>
          <p class="gj-sugo" *ngIf="szerk.naplo_partner_id">A Könyvelés partnertörzséből átvett cím – az itteni módosítás a partnertörzset nem érinti.</p>
          <p class="gj-sugo" *ngIf="szerk.ut_db">{{ szerk.ut_db }} út hivatkozik rá; a már rögzített utakon a cím szövege nem változik.</p>
        </div>
        <div class="sa-lab">
          <button type="button" class="ov-gomb fo" *ngIf="ir" [disabled]="zarolt || ment" (click)="mentes()"><ion-icon name="checkmark"></ion-icon>Mentés</button>
          <button type="button" class="kv-torol" *ngIf="ir && szerk.id" [disabled]="zarolt" (click)="torol()" title="Cím törlése"><ion-icon name="trash-outline"></ion-icon></button>
          <span class="spacer"></span><button type="button" class="ov-gomb" (click)="bezar()">Bezár</button>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- ═══ ÁTVÉTEL A KÖNYVELÉS PARTNERTÖRZSÉBŐL ═══ -->
<ion-modal [isOpen]="!!atvetel" (didDismiss)="atvetel = null" cssClass="sorablak-modal" style="--max-width: 860px">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Átvétel a Könyvelés partnertörzséből</ion-title></ion-toolbar></ion-header>
    <div class="sa-torzs">
      <div class="sa" *ngIf="atvetel">
        <div class="n-szuro-sor" style="margin:-16px -20px 0">
          <input type="search" [(ngModel)]="atvetel.kereso" placeholder="Név, adószám, település…" style="min-width:240px">
          <span class="spacer"></span>
          <span class="halvany">{{ atvetel.kijelolt.size }} kijelölve · {{ atvetel.lista.length }} partner</span>
        </div>
        <div class="tabla-wrap" style="max-height:55vh;overflow:auto">
          <table class="n-racs sz-racs">
            <thead><tr><th><input type="checkbox" [checked]="mindKijelolve" (change)="mindValt($any($event.target).checked)" title="A látható, még át nem vett partnerek"></th>
              <th>Név</th><th>Adószám</th><th>Cím</th><th></th></tr></thead>
            <tbody>
              <tr *ngFor="let p of atvetelLathato" [class.halvany-sor]="p.atveve" [class.kattinthato]="!p.atveve" (click)="!p.atveve && valt(p, !atvetel.kijelolt.has(p.id))">
                <td (click)="$event.stopPropagation()"><input type="checkbox" [disabled]="p.atveve" [checked]="p.atveve || atvetel.kijelolt.has(p.id)" (change)="valt(p, $any($event.target).checked)"></td>
                <td><b>{{ p.nev }}</b></td><td>{{ p.adoszam }}</td><td>{{ p.teljes }}</td>
                <td><span class="sz-allapot" data-a="kesz" *ngIf="p.atveve">már a címtárban</span></td>
              </tr>
            </tbody>
          </table>
          <div class="sz-ures" *ngIf="atvetel.betolt">Betöltés…</div>
          <div class="sz-ures" *ngIf="!atvetel.betolt && !atvetel.lista.length">A cégnek nincs partnere a Könyvelésben (önálló módban a Könyvelés partnertörzse nem érhető el).</div>
        </div>
        <div class="sa-lab">
          <button type="button" class="ov-gomb fo" [disabled]="!atvetel.kijelolt.size" (click)="atvetelMent()"><ion-icon name="download-outline"></ion-icon>{{ atvetel.kijelolt.size }} partner átvétele</button>
          <span class="spacer"></span><button type="button" class="ov-gomb" (click)="atvetel = null">Bezár</button>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>
